var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:_vm.refName,attrs:{"model":_vm.model,"label-width":_vm.labelWidth,"rules":_vm.rules}},[_vm._t("default"),_vm._v(" "),(_vm.showButton)?_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onSubmit}},[_vm._v(_vm._s(_vm.submitText))])],1):_vm._e()],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dc51349","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/zzcbpmDashboard/common/m-form.vue
// module id = null
// module chunks = 